import "core-js/modules/es.array.push.js";
import { insertVistor } from "@/api/visitor";
import { validIdCard, validPhone, validLicense } from "@/utils/valid";
import { defineComponent, reactive, ref, watch, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { showNotify } from "vant";
import Bus from "@/utils/eventBus";
let label = reactive({
  companyName: "",
  deptName: "",
  interviewerName: ""
});
let modelForm = reactive({
  companyId: "",
  deptId: "",
  interviewerId: "",
  name: "",
  phone: "",
  cardId: "",
  beginTime: "",
  endTime: "",
  workUnit: "",
  visitorNum: "1",
  visitReason: "",
  license: "",
  photoPath: ""
});
// 校验身份证号
const validCard = val => validIdCard(val, true);
// 校验车牌号
const valLicense = val => validLicense(val, true);
export default defineComponent({
  name: "VisitorNormal",
  setup() {
    const router = useRouter();
    const route = useRoute();
    let type = ref("VisitorNormalPark");
    watch(() => route, val => {
      type.value = val.name;
    }, {
      immediate: true
    });
    const isPark = computed(() => type.value === "VisitorNormalPark");
    let showPicker = ref(false);
    // 显示日期选择组件
    let field = ""; // 赋值字段
    const handlerClcikTime = fieldName => {
      field = fieldName;
      showPicker.value = true;
    };
    const dateChange = res => {
      modelForm[field] = res;
    };
    const loading = ref(false);
    const onSubmit = values => {
      if (new Date(modelForm.beginTime).getTime() >= new Date(modelForm.endTime).getTime()) {
        showNotify({
          type: "danger",
          message: "开始时间不能大于等于结束时间"
        });
        return;
      }
      loading.value = true;
      insertVistor(modelForm).then(({
        code,
        msg
      }) => {
        if (code === 200) {
          var _importRef$value;
          // router.go(-1);
          showNotify({
            type: "success",
            message: msg
          });
          // 置空
          modelForm.companyId = "";
          modelForm.deptId = "";
          modelForm.interviewerId = "";
          modelForm.name = "";
          modelForm.phone = "";
          modelForm.cardId = "";
          modelForm.beginTime = "";
          modelForm.endTime = "";
          modelForm.visitorNum = "";
          modelForm.workUnit = "";
          modelForm.visitReason = "";
          modelForm.license = "";
          modelForm.photoPath = "";
          label.companyName = "";
          label.deptName = "";
          label.interviewerName = "";
          (_importRef$value = importRef.value) === null || _importRef$value === void 0 || _importRef$value.setData([]);
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    let cellField = "";
    const onCell = (field, valid, msg) => {
      if (!modelForm[valid] && valid != "0") {
        showNotify({
          type: "warning",
          message: msg
        });
        return;
      }
      cellField = field;
      const title = cellField == "dept" ? "部门" : cellField == "interviewer" ? "人员" : isPark.value ? "企业" : "学校";
      router.push("/visitor/search?field=" + cellField + "&title=" + title + "&companyId=" + modelForm.companyId + "&deptId=" + modelForm.deptId);
    };
    const importRef = ref();
    return {
      importRef,
      type,
      isPark,
      modelForm,
      label,
      validPhone,
      validCard,
      valLicense,
      showPicker,
      dateChange,
      handlerClcikTime,
      loading,
      onSubmit,
      onCell
    };
  }
});
Bus.$on("searchChange", data => {
  label[data.field + "Name"] = data.name;
  modelForm[data.field + "Id"] = data.id;
});